












import {ChartDataTemplate, FCConfTpl, WConfTpl, WidgetDefinition, WParamTpl} from '@/components/widgets/WidgetFather'
import {defineComponent, reactive} from "@vue/composition-api"
import FusionChartWidget from "@/components/widgets/FusionChartWidget.vue"
import {getLocationCaption} from "@/data/sources/appraisal"
import {executeQuery} from "@/data/repos/query";
import appConfig from "@/config";
import {aggregateSpaceStatus} from "@/data/sources/ericSpaceStatus";


export function config(): WidgetDefinition {
    return {
      ...WConfTpl.MultiLevelPie(),
      widget: "SpaceStatus",
      title: "Space status",
      _description: "Space status",
      params: {
        locationId: {...WParamTpl.locationId(), _order: 1},
      },
      fusionChartParams: {
      },
    }
  }

  function getChartConfig() {
    return reactive(FCConfTpl())
  }

  function getChartDataConfig() {
    return reactive({
        ...ChartDataTemplate(),
        caption: 'Floor Area, Sq.m',
      // centerAngle: "270",
        // plotToolText: "$label, $$valueK, $percentValue",
        // enableSmartLabels: "1",
        // setadaptiveymin: '1',
      bgColor: "#FFFFFF",
      hoverFillColor: "#F0F0F0",
        showLegend: '0',
        // labelDisplay: '$label , $value',
        showLabels: '1',
        showValues: "0",
      inThousandSeparator: ",",
      centerAngle: "180",
        formatNumberScale: "0",
        // legendCaption: 'Rooms',
      },
    )
  }

  const chartDSTemplate = () => {
    return {category: []}
  }

  async function configChangeCallback(config: any, chartConfig: any, chartDataConfig: any) {
    if (config) {
      chartDataConfig.subCaption = "Location: " + await getLocationCaption(config.params.locationId)
    }
  }

  export default defineComponent({
    props: {
      config: Object,
    },
    components: {
      FusionChartWidget,
    },
    setup(props, context) {
      context.emit("config-update", config())

      async function dataFetcher(params: any): Promise<object> {
        const cpInfo = await executeQuery("idr", "custom_property", {
          cgName: "2020 ERIC Space Status",
          cpName: "ERIC Space Status"
        })
        const cpId = cpInfo.length === 1 ? cpInfo[0].cp_id : undefined // todo error handling
        const data: any[] = await executeQuery(
            "idr",
            "eric.spaceStatus", {
              locationId: parseInt(params.locationId.value),
              cpId: cpId
            });
        // console.info("SpaceStatus:", data)
        /*
          INSERT INTO #ERICColours ( requirement, colour)VALUES ( 'cli'       , '#6DCC77')
          INSERT INTO #ERICColours ( requirement, colour)VALUES ( 'non'       , '#6DA2CC')
          INSERT INTO #ERICColours ( requirement, colour)VALUES ( 'ret'       , '#A569BD')
          INSERT INTO #ERICColours ( requirement, colour)VALUES ( 'lea'       , '#F3D385')
          INSERT INTO #ERICColours ( requirement, colour)VALUES ( 'uno'       , '#C0C0C0')
          INSERT INTO #ERICColours ( requirement, colour)VALUES ( 'una'       , '#FF0000');
         */
        /*
          "category": [{
            "label": "Total Floor Area {br}57,757.40 Sq.m",
            "color": "#ffffff",
            "value": "57757.4",
            "category": [
         */
        return {
          category: [aggregateSpaceStatus(data)],
        }
      }

      function dataplotClickCallback(label: string, val: any) {
        const iprUrl = appConfig.IPR_BASE_URL
        const locationId = props.config.params.locationId.value
        window.open(iprUrl + `/pages/eric_site.asp?id=${locationId}&return=site_details.aspx?id=${locationId}`)
        console.log("chartClickCallback", label, val)
      }

      return {dataFetcher, chartDSTemplate, getChartDataConfig, dataplotClickCallback, configChangeCallback}
    },
  })
